import { Snackbar } from 'src/app/shared/types/snackbar';

export const snackbarObjectFailedGenerate: Snackbar = {
  duration: 2000,
  message: 'profile.api_key.snackbar_failed_generate',
  horizontalPosition: 'center',
  verticalPosition: 'top',
  type: 'error-snackbar',
};
